export class ClientBrowser {
    browserVersion = ""
    browser = ""
}